module.exports = __webpack_public_path__ + "static/media/Illustration_closepath.d9c16a46.svg";